export default __webpack_public_path__ + "static/mobile-app-development-66639b817a5d231b921fd2fd7f4642c5.webp";